import { Grid, MenuItem, TextField, Typography } from "@mui/material";
import { useEffect } from "react";

const PersonalInfoStep = ({ props }) => {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [])

    return (
        <Grid container spacing={2}>
            <Typography variant="h6" color={'primary'} textAlign={'center'}>Hospital/Institution info</Typography>
            <Grid item xs={12}>
                <TextField
                    label="Facility name"
                    id="outlined-size-small"
                    name="name"
                    value={props.formData.name}
                    size="small"
                    fullWidth
                    onChange={e => props.handleInputChange(e)}
                    helperText={props.emptyFormProps.includes('name') ? 'This field is required' : ''}
                    error={!!props.emptyFormProps.includes('name')}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <TextField
                    label="Address"
                    id="outlined-size-small"
                    name="address"
                    value={props.formData.address}
                    size="small"
                    fullWidth
                    onChange={e => props.handleInputChange(e)}
                    helperText={props.emptyFormProps.includes('address') ? 'This field is required' : ''}
                    error={!!props.emptyFormProps.includes('address')}

                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <TextField
                    label="City"
                    id="outlined-size-small"
                    name="city"
                    value={props.formData.city}
                    size="small"
                    fullWidth
                    onChange={e => props.handleInputChange(e)}
                    helperText={props.emptyFormProps.includes('city') ? 'This field is required' : ''}
                    error={!!props.emptyFormProps.includes('city')}

                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <TextField
                    id="outlined-select-country"
                    name="country"
                    select
                    label="Country"
                    value={props.formData.country}
                    size="small"
                    fullWidth
                    onChange={e => props.handleInputChange(e)}
                    helperText={props.emptyFormProps.includes('country') ? 'This field is required' : ''}
                    error={!!props.emptyFormProps.includes('country')}
                >
                    {props.countryOptions.map((option) => (
                        <MenuItem sx={{ '& > img': { mr: 2, flexShrink: 0 } }} key={option.value} value={option.value}>
                            <img
                                loading="lazy"
                                width="20"
                                srcSet={option.flag}
                                src={option.flag}
                                alt=""
                            />
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>
            <Grid item xs={12}>
                <TextField
                    label="Contact person"
                    id="outlined-size-small"
                    name="contact_person"
                    value={props.formData.contact_person}
                    size="small"
                    fullWidth
                    onChange={e => props.handleInputChange(e)}
                    helperText={props.emptyFormProps.includes('contact_person') ? 'This field is required' : ''}
                    error={!!props.emptyFormProps.includes('contact_person')}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    label="Phone number"
                    id="outlined-size-small"
                    name="phone_number"
                    value={props.formData.phone_number}
                    size="small"
                    fullWidth
                    onChange={e => props.handleInputChange(e)}
                    helperText={props.emptyFormProps.includes('phone_number') ? 'This field is required' : ''}
                    error={!!props.emptyFormProps.includes('phone_number')}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    label="Email"
                    id="outlined-size-small"
                    name="email"
                    value={props.formData.email}
                    size="small"
                    fullWidth
                    type="email"
                    helperText={props.emailError !== '' ? props.emailError : props.emptyFormProps.includes('email') ? 'This field is required' : ''}
                    error={!!props.emailError || !!props.emptyFormProps.includes('email')}
                    onBlur={props.handleEmailBlur}
                    onChange={e => props.handleInputChange(e)}
                />
            </Grid>
        </Grid>
    )
}

export default PersonalInfoStep;